<template>
  <div class="text-slider-container">
    <div class="demo">
      <div class="bg-gradient text-transparent bg-clip-text">
        Ventilation Hygiene
      </div>
      <div class="bg-gradient text-transparent bg-clip-text">
        Ductwork Cleaning
      </div>
      <div class="bg-gradient text-transparent bg-clip-text">
        Asbestos Remediation
      </div>
    </div>
  </div>
</template>

<style>
.text-slider-container {
  display: flex;
}

.demo {
  width: 150px;
  color: #fff;
  text-align: left;
  display: flex; /* Add this line to make it a flex container */
  align-items: center; /* Center text vertically */
  overflow: hidden;
  height: 50px;
}

.demo div {
  height: 60px;
  position: absolute;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
}
</style>

<script setup>
import { gsap } from "gsap";
import { onMounted } from "vue";

const animation = gsap.timeline({ repeat: -1 });
let targets;
const duration = 1.2;

const stagger = duration;

onMounted(() => {
  targets = document.querySelectorAll(".demo div");
  const numberOfTargets = targets.length;
  const repeatDelay = stagger * (numberOfTargets - 1);

  gsap.set(".demo", { autoAlpha: 1 });
  animation
    .from(targets, {
      y: 40,
      duration: duration,
      opacity: 0,
      stagger: {
        each: stagger,
        repeat: -1,
        repeatDelay: repeatDelay,
      },
      ease: "elastic.out(1, 0.7)",
    })
    .to(
      targets,
      {
        y: -40,
        duration: duration,
        opacity: 0,
        stagger: {
          each: stagger,
          repeat: -1,
          repeatDelay: repeatDelay,
        },
        ease: "elastic.out(1, 0.7)",
      },
      stagger
    );
});

// Click anywhere to pause

/* Learn the GreenSock Animation Platform (GSAP 3) https://courses.snorkl.tv/courses/gsap-3-express */
</script>
